<script setup>
import { ref, computed } from 'vue'
import { useProductListStore } from '@/store'

// Initialize the store
const store = useProductListStore()

// Local state
const showButtons = ref(3)

// Computed properties
const currentPage = computed(() => store.pageNumber + 1)
const lastPage = computed(() => store.totalPages - 1)

const startPage = computed(() => {
  if (currentPage.value === 1 || store.totalPages <= showButtons.value) {
    return 1
  }
  if (currentPage.value === store.totalPages || currentPage.value + showButtons.value - 1 >= store.totalPages) {
    return store.totalPages - showButtons.value + 1
  }
  return currentPage.value - Math.floor(showButtons.value / 2) > 1
    ? currentPage.value - Math.floor(showButtons.value / 2)
    : 1
})

const pages = computed(() => {
  const range = []
  for (let i = startPage.value; i <= Math.min(startPage.value + showButtons.value - 1, store.totalPages); i += 1) {
    range.push(i)
  }
  return range
})

// Methods
function handleUpdateCurrentPageNumber(id) {
  document.getElementsByClassName('tx-itemrepo--list')[0].scrollIntoView({ behavior: 'smooth' })
  store.updateCurrentPageNumber(id)
}
</script>

<template>
  <div class="content-item module-pagination">
    <div
      class="pagination__button pagination__button--prev"
      :class="{ '-disabled': currentPage === 1 }"
      @click="currentPage !== 1 ? handleUpdateCurrentPageNumber(currentPage - 2) : ''"
    >
      <span class="meta">{{ $t('pagination.back') }}</span>
    </div>
    <div class="pagination__pagination">
      <div
        class="pagination__button"
        v-if="startPage > 1"
        @click="handleUpdateCurrentPageNumber(0)"
      >
        <span class="meta">1</span>
      </div>
      <div
        class="pagination__button pagination__button--placeholder"
        v-if="startPage > 2"
      >
        <span class="meta">...</span>
      </div>
      <div
        class="pagination__button"
        v-for="page in pages"
        :class="{ '-active': currentPage === page }"
        :key="'page-' + page"
        @click="handleUpdateCurrentPageNumber(page - 1)"
      >
        <span class="meta">{{ page }}</span>
      </div>
      <div
        class="pagination__button pagination__button--placeholder"
        v-if="startPage + showButtons - 1 < store.totalPages - 1"
      >
        <span class="meta">...</span>
      </div>
      <div
        class="pagination__button"
        v-if="startPage + showButtons - 1 < store.totalPages"
        @click="handleUpdateCurrentPageNumber(lastPage)"
      >
        <span class="meta">{{ store.totalPages }}</span>
      </div>
    </div>
    <div
      class="pagination__button pagination__button--next"
      :class="{ '-disabled': currentPage === store.totalPages }"
      @click="currentPage !== store.totalPages ? handleUpdateCurrentPageNumber(currentPage) : ''"
    >
      <span class="meta">{{ $t('pagination.next') }}</span>
    </div>
  </div>
</template>
